import {
  Avatar,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  StepContent,
  StepLabel,
  Stepper,
  styled,
  Step,
  Divider,
  Grid,
} from "@mui/material";
import { useContext, useState } from "react";
import History from "../History";
import Dune from "../Dune";
import SessionContext from "../../contexts/session";
import GAMES from "../../games";
import { FormatGui } from "../../utils";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import SentimentSatisfiedAltRoundedIcon from "@mui/icons-material/SentimentSatisfiedAltRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { isMobile, isTablet } from "react-device-detect";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import StarIcon from "@mui/icons-material/Star";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import CountUp from "react-countup";

export default function Home() {
  const { selectedNetwork, settings, user } = useContext(SessionContext);
  const { t } = useTranslation();

  const duneStats = {
    //weekly_avg_unique_users: t("Weekly Avg Unique Users"),
    weekly_avg_txs: t("Weekly Avg Txs"),
    unique_players: t("Unique Players"),
    averagebetamount: t("Average Bet Amount"),
    bets: t("Bets"),
  };

  const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    }),
    ...(ownerState.completed && {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    }),
  }));

  function ColorlibStepIcon(props) {
    const { active, completed, className } = props;

    const icons = {
      1: <IntegrationInstructionsIcon />,
      2: <RemoveRedEyeIcon />,
      3: <StarIcon />,
      4: <HealthAndSafetyIcon />,
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }
  return (
    <>
      <Stack>
        {user?.verified && (
          <>
            <Typography variant="h6" color="primary.light">
              <Trans t={t}>Welcome back </Trans>
              <Box component="span" sx={{ color: "secondary.main" }}>
                @
              </Box>
              {user?.username}!
            </Typography>
            <Typography>
              <Trans t={t}>We missed you!</Trans>
            </Typography>
            <Typography></Typography>
          </>
        )}
      </Stack>
      <Stack direction="row" spacing={2} sx={{ overflowX: "scroll" }}>
        {Object.values(GAMES).map((game) => (
          <GameListItem key={t(game.name)} game={game} />
        ))}
      </Stack>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        {[
          {
            icon: <CasinoRoundedIcon />,
            name: t("Current jackpot"),
            value: (
              <FormatGui
                wei={settings?.jackpotSize || 0}
                network={selectedNetwork}
              />
            ),
          },
          {
            icon: <BarChartRoundedIcon />,
            name: t("Total wagered"),
            value: (
              <FormatGui
                wei={settings?.totalWagered || 0}
                network={selectedNetwork}
              />
            ),
          },
          {
            icon: <SentimentSatisfiedAltRoundedIcon />,
            name: t("Wait time"),
            value: `${Math.floor((settings?.waitTime || 0) / 1000)}s`,
          },
        ].map((stat) => (
          <Stack
            key={stat.name}
            component={Paper}
            variant="outlined"
            spacing={2}
            sx={{ flex: 1, alignItems: "center", py: 4 }}
          >
            <Stack spacing={1} sx={{ alignItems: "center" }}>
              <Avatar>{stat.icon}</Avatar>
              <Typography>{stat.name}</Typography>
            </Stack>
            <Typography>{stat.value}</Typography>
          </Stack>
        ))}
      </Stack>
      {(isMobile || isTablet) && (
        <Stack
          component={Paper}
          sx={{ p: 4, px: 6, alignSelf: "center" }}
          spacing={2}
        >
          <Typography fontSize="large" color="primary.light">
            <Trans t={t}>How to play?</Trans>🐱
          </Typography>
          <Typography>
            <Trans t={t}>1. Choose a game from the list above</Trans>
          </Typography>
          <Typography>
            <Trans t={t}>2. Enter your bet amount and choose your inputs</Trans>
          </Typography>
          <Typography>
            <Trans t={t}>3. Click the 'Play' button</Trans>
          </Typography>
          <Typography>
            <Trans t={t}>4. Wait for the game to finish</Trans>
          </Typography>
          <Typography>
            <Trans t={t}>5. Receive your winnings</Trans>
          </Typography>
        </Stack>
      )}
      {!(isMobile || isTablet) && (
        <>
          <Stack
            spacing={2}
            component={Paper}
            variant="outlined"
            sx={{
              background: "none",
              alignItems: "center",
              p: 4,
              borderRadius: 2,
            }}
          >
            <Stack spacing={2} sx={{ alignItems: "center" }}>
              <Stack spacing={1} direction="row" sx={{ alignItems: "center" }}>
                <img src="/img/logo248.svg" height={34 + 34 / 2} />
                <Typography
                  color="primary"
                  variant="h5"
                  sx={{ fontWeight: "bold" }}
                ></Typography>
              </Stack>
              <Typography variant="h6">
                <Trans t={t}>Crypto gambling on web3 casino</Trans>
              </Typography>
            </Stack>
            <Divider sx={{ width: "100%" }}>
              <Trans t={t}>SPECIFICATIONS</Trans>
            </Divider>
            <Stepper activeStep={4} orientation="vertical">
              <Step expanded={true}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  <Trans t={t}>Decentralized</Trans>
                </StepLabel>
                <StepContent>
                  <Trans t={t}>
                    Trustless platform powered by immutable smart contracts
                  </Trans>
                </StepContent>
              </Step>
              <Step expanded={true}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  <Trans t={t}>Provably Fair</Trans>
                </StepLabel>
                <StepContent>
                  <Stack spacing={1}>
                    <Typography>
                      <Trans t={t}>Only 1% edge per bet</Trans>
                    </Typography>
                    <Typography>
                      <Trans t={t}>
                        Transparent odds and gameplay securing fair-play for all
                      </Trans>
                    </Typography>
                    <a
                      href={selectedNetwork.ui.explorerUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Button variant="text">
                        <Trans t={t}>View smart contract</Trans>
                      </Button>
                    </a>
                  </Stack>
                </StepContent>
              </Step>
              <Step expanded={true}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  <Trans t={t}>Earn Rewards</Trans>
                </StepLabel>
                <StepContent>
                  <Trans t={t}>Accumulate $N2W</Trans>{" "}
                  <img src="/img/token2.svg" width={24} /> —{" "}
                  <Trans t={t}>the platform token</Trans> —{" "}
                  <Trans t={t}>while playing</Trans>
                </StepContent>
              </Step>
              <Step expanded={true}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  <Trans t={t}>Anonymous Experience</Trans>
                </StepLabel>
                <StepContent>
                  <Trans t={t}>
                    Non-custodial gambling ensuring no KYC or frozen funds
                  </Trans>
                </StepContent>
              </Step>
            </Stepper>
          </Stack>
          <History all={true} />
        <Dune></Dune>
        </>
      )}
    </>
  );
}

function GameListItem({ game }) {
  const [mouseOn, setMouseOn] = useState(false);
  const { t } = useTranslation();

  return (
    <Link
      onMouseOver={() => {
        setMouseOn(true);
      }}
      onMouseLeave={() => {
        setMouseOn(false);
      }}
      to={game.url}
      style={{
        textDecoration: "none",
        position: "relative",
        top: mouseOn ? "-10px" : 0,
        transitionProperty: "all",
        transitionDuration: "0.3s",
        transitionTimingFunction: "ease",
      }}
    >
      <Stack
        component={Paper}
        sx={{
          background: game.bg,
          backgroundSize: "155px 210px",
          width: "155px",
          height: "210px",
          alignItems: "center",
          justifyContent: "center",
          py: 2,
          mt: 2,
          position: "relative",
          borderRadius: 1,
        }}
      >
        {game.new && (
          <Box
            sx={{
              background: "red",
              p: 0.5,
              position: "absolute",
              top: -3,
              right: -3,
              color: "white",
              borderRadius: 1,
              zIndex: 1,
            }}
          >
            new
          </Box>
        )}
        <Stack
          sx={{ flexGrow: 1, alignItems: "center", justifyContent: "center" }}
        >
          <img height={24 * 2} src={game.iconUrl} alt={game.alt} />
        </Stack>
        <Typography variant="h5" sx={{ textDecoration: "none" }}>
          {t(game.name)}
        </Typography>
        <Typography variant="subtitle2">{t(game.description3)}</Typography>
        <Paper
          component={Stack}
          sx={{
            width: "155px",
            height: "210px",
            position: "absolute",
            background: "#2071e4",
            opacity: mouseOn ? 0.95 : 0,
            transitionProperty: "all",
            transitionDuration: "0.3s",
            transitionTimingFunction: "ease",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Typography sx={{ alignSelf: "flex-start", marginBottom: "auto" }}>
            {t(game.name)}
          </Typography>
          <Box sx={{ fontSize: "75px" }}>
            <PlayArrowRoundedIcon fontSize="inherit" />
          </Box>
          <Typography
            variant="subtitle2"
            sx={{ alignSelf: "flex-start", marginTop: "auto" }}
          >
            <Trans t={t}>N2W Originals</Trans>
          </Typography>
        </Paper>
      </Stack>
    </Link>
  );
}
